var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMakerPin = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6.66669C2 3.35298 4.68629 0.666687 8 0.666687C11.3137 0.666687 14 3.35298 14 6.66669C14 8.3508 13.2354 9.82684 12.1949 11.178C11.3253 12.3071 10.2122 13.4106 9.10043 14.5127L9.09965 14.5135C8.88964 14.7217 8.67968 14.9298 8.4714 15.1381C8.21106 15.3984 7.78895 15.3984 7.5286 15.1381C7.32018 14.9297 7.1096 14.7209 6.89944 14.5126C5.78764 13.4104 4.6747 12.3071 3.80515 11.178C2.76455 9.82684 2 8.3508 2 6.66669ZM10 6.66669C10 7.77126 9.10457 8.66669 8 8.66669C6.89543 8.66669 6 7.77126 6 6.66669C6 5.56212 6.89543 4.66669 8 4.66669C9.10457 4.66669 10 5.56212 10 6.66669Z",
    fill: "#717B84"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMakerPin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Maker-pin.45f564992458a8e6f2b72fa965b08c6b.svg";